<script setup lang="ts">
import type { Swiper } from 'swiper/types';

const carousel = useTemplateRef('carousel_ref');
const swiper = computed(() => carousel.value?.swiper as Swiper | undefined);
</script>

<template>
  <PageContainerAlignment
    class="gap-r4 xl:gap-r16 flex flex-col items-start xl:flex-row xl:items-center"
  >
    <ServicesRelaxSaunaHeader :swiper />
    <ServicesRelaxSaunaCarousel ref="carousel_ref" />
  </PageContainerAlignment>
</template>
